import React from 'react';

const Blog = () => {
  return (
    <div className="font-[FixelVariable] min-h-screen flex items-center justify-center bg-custom-radial text-white">
      <h1 className="text-4xl md:text-6xl font-semibold text-center">Coming Soon...</h1>
    </div>
  );
};

export default Blog;

